import Controller from "csi/action/Controller";
import declare from "dojo/_base/declare";
import PostRequest from "csi/comm/PostRequest";
import xml from "csi/xml";

const AbortFileGenerationController = declare(Controller, {

	/**
	 * @override
	 * This method determines the appropriate action
	 * If DGaaSTemplateRevision is defined in the Document Revision (DocRev), calls CancelDocumentGeneration operation
	 */
	process() {
		const currentRevision = this.getNode();
		const dGaaSTemplateRevisionUrl = currentRevision.DGaaSTemplateRevision;
		if (xml.isValidURL(dGaaSTemplateRevisionUrl)) {
			const cancelGenerationRequest = new PostRequest("DocumentGenerator", "CancelDocumentGeneration");
			cancelGenerationRequest.addParameter("DocumentRevision", currentRevision.$URL);
			this.waitForPublish(cancelGenerationRequest.post());
		}
	},
});

export = AbortFileGenerationController;
